import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'day'
})
/**
 * 將 yyyyMMdd 格式（例如：20260521）只取 dd（例如：21）
 */
export class DayPipe implements PipeTransform {
  transform(value: string): string {
    if (!/^\d{8}$/.test(value)) {
    return '';
    }
    if (!value || value.length !== 8) return '';
    return value.slice(6, 8); // 取 dd
  }
}